<template lang="pug">
  .field-driver-info(v-if="$is('driver-info')")
    driver-fields(:fieldName="'driver-status'", :item="item")
    driver-fields(:fieldName="'driver-id'", :item="item")
    driver-fields(:fieldName="'driver-fullname'", :item="item")

  .field-driver-info-no-status(v-else-if="$is('driver-info-no-status')")
    driver-fields(:fieldName="'driver-id'", :item="item")
    driver-fields(:fieldName="'driver-fullname'", :item="item")

  .field-driver-status(v-else-if="$is('driver-status')")
    status(:status="item.status", class="float-left")
    .field-value {{item.status}}


  .field-driver-id(v-else-if="$is('driver-id')")
    router-link(:to="{name:'driver', params:{id:item.id}}" ) DR{{item.id}}
  .field-driver-uid(v-else-if="$is('driver-uid')")
    .field-value {{item.uid}}
  .field-client-info(v-else-if="$is('client-info')")
    .field-value
      router-link(:to="{name:'client', params:{id:item.client_id}}") CL{{item.client_id}}
    .field-value {{item.client_name}}


  .field-city(v-else-if="$is('city')")
    .field-value {{item.address.city}}

  .field-created(v-else-if="$is('created')")
    .field-value {{$dateFormat(item.created,$toMomentFormat(configuration.locale.locale_datetime_format.value))}}
  .field-updated(v-else-if="$is('updated')")
    .field-value {{$dateFormat(item.updated,$toMomentFormat(configuration.locale.locale_datetime_format.value))}}

  .field-phone-and-email(v-else-if="$is('phone-and-email')")
    .field-phone {{item.phone}}
    .field-email {{item.email}}
  .driver-fullname(:fieldName="'driver-name'", v-else-if="$is('driver-fullname')")
    router-link(:to="{name:'driver', params:{id:item.id}}" )  {{item.name}} {{item.surname}}

  .driver-name(:fieldName="'driver-name'", v-else-if="$is('driver-name')") {{item.name}}
  .driver-surname(:fieldName="'driver-surname'", v-else-if="$is('driver-surname')") {{item.surname}}
  .driver-gender(:fieldName="'driver-gender'", v-else-if="$is('driver-gender')") {{item.gender}}
  .driver-country(:fieldName="'driver-country'", v-else-if="$is('driver-country')") {{item.address.country}}

  .driver-id(:type="'driver-id'", v-else-if="$is('driver-id')")
    router-link(:to="{name:'driver', params:{id:item.id}}" ) {{item.name}} {{item.surname}}

</template>
<script type="text/babel">
  import Status from "../Status.vue";
  import {mapState} from 'vuex'

  export default {
    name: "DriverFields",
    components: {Status},
    data() {
      return {}
    },
    created() {
    },
    methods: {},
    computed: {
      type() {
        return this.fieldName
      },
      ...mapState({
        configuration: state => state.configuration,
      })
    },
    props: {
      item: Object,
      fieldName: {
        type: String,
        default: ''
      }
    },
  }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// DriverFields.vue?1ea1acc0